export enum IconColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Inverse = 'inverse',
  Default = 'default',
  TrimbleGray = 'trimble-gray',
}
